import { render, staticRenderFns } from "./ProductsBlock.vue?vue&type=template&id=69b74793&scoped=true"
import script from "./ProductsBlock.vue?vue&type=script&lang=js"
export * from "./ProductsBlock.vue?vue&type=script&lang=js"
import style0 from "./ProductsBlock.vue?vue&type=style&index=0&id=69b74793&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b74793",
  null
  
)

export default component.exports